import React from "react";
import Icon from "../Icon";

export interface SpinnerProps {
	classes?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ classes = "" }) => {
	return (
		<div className={`spinner ${classes}`}>
			<Icon icon="spinner-third" classes="fa-spin" />
		</div>
	);
};

export default Spinner;
